<style lang="less">
    .disable {
        cursor: not-allowed !important;
        opacity: 0.4;
    }
</style>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" :showTippy="false" />
</template>

<script lang="ts">
    declare var EDDocument: any;
    import { Component, Watch, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class ViewDrops extends Vue {
        activeKey = "";

        showExpand(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            if (node.parentElement.className.includes("redpoint-box")) {
                node = node.parentElement;
            }
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", type, node.offsetTop - scrollTop);
            if (["toolbars", "grid", "guides", "margins"].includes(type)) {
                this.$store.commit("setStatus", {
                    type: "showDropExpand",
                    data: true,
                });
            }
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        toggleLib() {
            this.showLib = !this.showLib;
            this.closeDrop();
            // 等待UI更新完成后调用onsize -> updatesceneSize
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }
        toggleData() {
            this.showDataSheet = !this.showDataSheet;
            this.closeDrop();
        }
        viewClick(type: string) {
            let view = window["_view"];
            this.$track("menu", "view", type);
            switch (type) {
                case "zoomIn":
                    view.zoomUp();
                    break;
                case "zoomOut":
                    view.zoomDown();
                    break;
                case "zoomContent":
                    view.fitPageContent();
                    break;
                case "zoomWidth":
                    view.fitPageWidth();
                    break;
                case "zoomPage":
                    view.fitToWindow();
                    break;
                default:
                    break;
            }
        }
        toggleRuler() {
            let view = window["_view"];
            if (!view) return;

            let checked = !view._doc._config._showRuler;
            this.$track("menu", "view", checked + "ruler");
            view.showRulersBox(checked);
            this.closeDrop();
        }
        pageBreak() {
            let view = window["_view"];
            if (!view) return;

            let checked = !this.showPageBreak;
            this.$track("menu", "view", checked + "pageBreak");
            view.pageBreaksBox(checked);
            this.closeDrop();
        }
        toggleFloatBtn() {
            let checked = !EDDocument._gcfg._hideFloatButton;
            this.$track("menu", "view", checked + "floatbtn");
            window["_view"].setHideFloatBtn(checked);
            this.closeDrop();
        }
        toggleMovecoordinate() {
            window["_view"].showMoveCoordinate();
            this.closeDrop();
        }
        pageFitShape() {
            window["_view"].fittoDrawing();
            this.$track("menu", "view", "pageFitShape");
            this.closeDrop();
        }

        get hasShapes() {
            let layers = this.$store.state.page.activedPageLayers,
                len = layers.length;
            for (let i = 0; i < len; i++) {
                if (layers[i].count > 0) return true;
            }
            return false;
        }
        get showLib() {
            return this.$store.state.ui.showLibrary;
        }
        set showLib(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showLibrary",
                data: v,
            });
        }
        get showDataSheet() {
            return this.$store.state.ui.showDataSheet;
        }
        set showDataSheet(v: boolean) {
            this.$store.commit("setStatus", {
                type: "showDataSheet",
                data: v,
            });
            if (v) {
                this.$store.commit("setStatus", {
                    type: "dataSheetHeight",
                    data: 200,
                });
            } else {
                this.$store.commit("setStatus", {
                    type: "dataSheetHeight",
                    data: 0,
                });
            }
        }
        get showRuler() {
            return this.$store.state.page.showRuler;
        }
        get showPageBreak() {
            return this.$store.state.page.showPageBreak;
        }
        get showFloatBtn() {
            return this.$store.state.page.showFloatBtn;
        }
        get showMovecoordinate() {
            return this.$store.state.page.showMovecoordinate;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        get menuList() {
            let list = [
                {
                    key: "zoomIn",
                    shortcut: "Ctrl +",
                    extraClass: this.activeFunc == "viewZoomIn" && "activeFunc",
                },
                {
                    key: "zoomOut",
                    shortcut: "Ctrl -",
                    extraClass: this.activeFunc == "viewZoomOut" && "activeFunc",
                },
                {
                    key: "zoomContent",
                    extraClass: this.activeFunc == "viewFitToContent" && "activeFunc",
                },
                {
                    key: "zoomWidth",
                    extraClass: this.activeFunc == "viewFitToPageWidth" && "activeFunc",
                },
                { key: "zoomPage", extraClass: this.activeFunc == "viewFitToPage" && "activeFunc" },
                { divide: true },
                {
                    key: "pageFitShape",
                    disabled: !this.hasShapes,
                    extraClass: this.activeFunc == "viewFitToDrawing" && "activeFunc",
                },
                { divide: true },
                {
                    key: "toolbars",
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "viewToolbar" && "activeFunc",
                },
                {
                    key: "grid",
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "viewGrid" && "activeFunc",
                },
                {
                    key: "guides",
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "viewGuides" && "activeFunc",
                },
                {
                    key: "margins",
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "viewMargins" && "activeFunc",
                },
                {
                    key: "ruler",
                    checked: this.showRuler,
                    extraClass: this.activeFunc == "viewRuler" && "activeFunc",
                },
                {
                    key: "floatBtn",
                    checked: this.showFloatBtn,
                    extraClass: this.activeFunc == "viewFloatButton" && "activeFunc",
                },
                {
                    key: "movecoordinate",
                    checked: this.showMovecoordinate,
                    extraClass: this.activeFunc == "viewMoveCoord" && "activeFunc",
                },
                {
                    key: "pageBreak",
                    checked: this.showPageBreak,
                    extraClass: this.activeFunc == "viewPageBreak" && "activeFunc",
                },
                { divide: true },
                {
                    key: "library",
                    checked: this.showLib,
                    extraClass: this.activeFunc == "viewShowLibrary" && "activeFunc",
                },
                {
                    key: "dataSheet",
                    shortcut: "F9",
                    checked: this.showDataSheet,
                    extraClass: this.activeFunc == "viewShowDataSheet" && "activeFunc",
                },
            ];
            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });

            let resultList = [];
            list.map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "view-drops", list: resultList };
        }
        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }

        @Watch("showDropdown")
        changeLayerOpertaion(val) {
            if (!val) {
                this.activeKey = "";
            }
        }

        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "zoomIn",
                    () => {
                        event.stopPropagation();
                        this.viewClick("zoomIn");
                    },
                ],
                [
                    "zoomOut",
                    () => {
                        event.stopPropagation();
                        this.viewClick("zoomOut");
                    },
                ],
                [
                    "zoomContent",
                    () => {
                        event.stopPropagation();
                        this.viewClick("zoomContent");
                    },
                ],
                [
                    "zoomWidth",
                    () => {
                        event.stopPropagation();
                        this.viewClick("zoomWidth");
                    },
                ],
                [
                    "zoomPage",
                    () => {
                        event.stopPropagation();
                        this.viewClick("zoomPage");
                    },
                ],
                [
                    "pageFitShape",
                    () => {
                        this.hasShapes && this.pageFitShape();
                    },
                ],
                [
                    "ruler",
                    () => {
                        this.toggleRuler();
                    },
                ],
                [
                    "floatBtn",
                    () => {
                        this.toggleFloatBtn();
                    },
                ],
                [
                    "movecoordinate",
                    () => {
                        this.toggleMovecoordinate();
                    },
                ],
                [
                    "pageBreak",
                    () => {
                        this.pageBreak();
                    },
                ],
                [
                    "library",
                    () => {
                        this.toggleLib();
                    },
                ],
                [
                    "dataSheet",
                    () => {
                        this.toggleData();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeKey = key;
            this.showExpand(event, key);
        }
        mounted() {}

        created() {}
        deactivated() {
            this.activeKey = "";
        }
    }
</script>
<i18n>
{
  "zh": {
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "zoomContent": "适应内容",
    "zoomWidth": "适应宽度",
    "zoomPage": "适应页面",
    "grid": "网格",
    "guides": "参考线",
    "margins": "页面边距",
    "ruler": "标尺",
    "floatBtn": "浮动按钮",
    "pageBreak": "分页符",
    "lineConnection": "lineConnection",
    "library": "显示符号库",
    "dataSheet": "显示数据表",
    "pageFitShape": "页面适应到形状",
    "toolbars": "自定义工具栏",
    "movecoordinate": "悬浮坐标值"
  },
  "en": {
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomContent": "Fit to Content",
    "zoomWidth": "Fit to Page Width",
    "zoomPage": "Fit to Whole Page",
    "grid": "Grid",
    "guides": "Guides",
    "margins": "Margins",
    "ruler": "Ruler",
    "floatBtn": "Float Button",
    "pageBreak": "Page Breaks",
    "lineConnection": "Line Connection",
    "library": "Show Library",
    "dataSheet": "Data Sheet",
    "pageFitShape": "Fit to Drawing",
    "toolbars": "Customize toolbars",
    "movecoordinate": "Symbol coordinate value"
  },
  "fr": {
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "zoomContent": "Ajuster au contenu",
    "zoomWidth": "Ajuster à la largeur de la page",
    "zoomPage": "Ajuster à la page",
    "grid": "Grille",
    "guides": " Guides",
    "margins": "Marges",
    "ruler": "Règle",
    "floatBtn": "Bouton flottant",
    "pageBreak": "Sauts de page",
    "lineConnection": "Connexion de Ligne",
    "library": "Afficher la Bibliothèque de Symboles",
    "dataSheet": "Afficher le tableau de données",
    "pageFitShape": "La page s'adapte à la forme",
    "toolbars": "Barre d'outils personnalisée",
    "movecoordinate": "Valeur des coordonnées du symbole"
  },
  "de": {
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "zoomContent": "Inhalt anpassen",
    "zoomWidth": "Seitenbreite anpassen",
    "zoomPage": "Der gesamten Seite anpassen",
    "grid": "Gitternetz",
    "guides": "Führungslinien",
    "margins": "Seitenränder",
    "ruler": "Messerlinien",
    "floatBtn": "Float Button",
    "pageBreak": "Seitenumbrüche",
    "lineConnection": "Linienverbindung",
    "library": "Bibliothek anzeigen",
    "dataSheet": "Datenverzeichnis",
    "pageFitShape": "Der Zeichnung anpassen",
    "toolbars": "Benutzerdefinierte Symbolleiste",
    "movecoordinate": "Symbol Koordinatenwert"
  },
  "jp": {
    "zoomIn": "ズームイン",
    "zoomOut": "ズームアウト",
    "zoomContent": "図面に合わせる",
    "zoomWidth": "幅に合わせる",
    "zoomPage": "ページに合わせる",
    "grid": "グリッドライン",
    "guides": "ガイドライン",
    "margins": "余白",
    "ruler": "ルーラー",
    "floatBtn": "アクションボタン",
    "pageBreak": "ページ区切り",
    "lineConnection": "線の接続",
    "library": "ライブラリを表示",
    "dataSheet": "データシートを表示",
    "pageFitShape": "図形に合わせる",
    "toolbars": "カスタムツールバー",
    "movecoordinate": "座標値"
  },
  "es": {
    "zoomIn": "Acercamiento",
    "zoomOut": "Alejar",
    "zoomContent": "Ajustar al contenido",
    "zoomWidth": "Ajustar al ancho de la página",
    "zoomPage": "Ajustar a toda la página",
    "grid": "Rejilla",
    "guides": "Guías",
    "margins": "Márgenes",
    "ruler": "Gobernante",
    "floatBtn": "Botón flotante",
    "pageBreak": "Saltos de página",
    "lineConnection": "Conexión de línea",
    "library": "Mostrar la biblioteca",
    "dataSheet": "Hoja de datos",
    "pageFitShape": "Ajustar al dibujo",
    "toolbars": "Personalizar barras de herramientas",
    "movecoordinate": "Valor de la coordenada del símbolo"
  },
  "pt": {
    "zoomIn": "Aumentar o Zoom",
    "zoomOut": "Diminuir o Zoom",
    "zoomContent": "Ajustar ao Conteúdo",
    "zoomWidth": "Ajustar à Largura da Página",
    "zoomPage": "Ajustar à Página Completa",
    "grid": "Grelha",
    "guides": "Guias",
    "margins": "Limites",
    "ruler": "Régua",
    "floatBtn": "Botão Flutuante",
    "pageBreak": "Intervalos de Página",
    "lineConnection": "Conexão de Linha",
    "library": "Mostrar Biblioteca",
    "dataSheet": "Folha de Dados",
    "pageFitShape": "Ajustar ao Desenho",
    "toolbars": "Personalizar Barras de Ferramentas",
    "movecoordinate": "Valor da coordenada do símbolo"
  },
  "it": {
    "zoomIn": "Zoom avanti",
    "zoomOut": "Zoom indietro",
    "zoomContent": "Adatta a Contenuto",
    "zoomWidth": "Adatta a Larghezza Pagina",
    "zoomPage": "Adatta alla Pagina",
    "grid": "Griglia",
    "guides": "Guide",
    "margins": "Margini",
    "ruler": "Righello",
    "floatBtn": "Pulsante Flottante",
    "pageBreak": "Interruzioni di Pagina",
    "lineConnection": "Connessione Lineare",
    "library": "Mostra Libreria",
    "dataSheet": "Scheda Dati",
    "pageFitShape": "Adatta al Disegno",
    "toolbars": "Barra degli strumenti personalizzata",
    "movecoordinate": "Valori delle coordinate"
  },
  "tw": {
    "zoomIn": "放大",
    "zoomOut": "縮小",
    "zoomContent": "適應內容",
    "zoomWidth": "適應寬度",
    "zoomPage": "適應頁面",
    "grid": "網格",
    "guides": "參考線",
    "margins": "頁面邊距",
    "ruler": "標尺",
    "floatBtn": "浮動按鈕",
    "pageBreak": "分頁符",
    "lineConnection": "連接線",
    "library": "顯示符號庫",
    "dataSheet": "顯示數據表",
    "pageFitShape": "頁面適合到形狀",
    "toolbars": "自定義工具夾",
    "movecoordinate": "懸浮坐標值"
  }
}
</i18n>
